import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { UiActions } from 'state/actions/UiActions';
import { Portal } from 'components/general/Portal';
import { Feedback } from 'components/feedback/Feedback';
import { Modal } from 'components/modal/Modal';

import Styles from 'views/pages/Caixinha.module.scss';
import { StateActions } from 'state/actions/StateActions';
import {
  PossibleSubscriberIds,
  IsOrWasSubscriber,
  FilterSubscriberByEditions,
} from 'core/utils/SubscriberUtils';
import { CopyToClipBoard } from 'utils/CopyToClipBoard';

class Caixinha extends Component {
  /**
   * @type {GlamboxLocalStore}
   */
  storeHandler = null;

  constructor(props) {
    super(props);

    this._mounted = false;

    this.state = {
      editionDetails: {
        data: null,
        pending: false,
        error: null,
      },
      editionProducts: {
        data: null,
        pending: false,
        error: null,
      },
      editionFeedback: {
        data: null,
        pending: false,
        error: null,
      },
      editionTracking: {
        data: null,
        pending: false,
        error: null,
      },

      editions: {
        glambox: [],
        superbox: [],
        subscriberEditions: [],
      },
      editionsParsed: false,

      subscriberIdList: [],
      subscriberHasSuperbox: false,

      currentEdition: null,
      currentEditionIsSuperbox: false,

      currentSubscriber: null,

      productFeedbackId: null,
      productFeedbackModal: false,

      activeFeedbackId: null,
      editionFeedbackModal: false,
    };
  }

  componentDidMount() {
    this._mounted = true;

    const { person, location, history, editions, subscribers } = this.props;

    if (Array.isArray(subscribers) && subscribers.length === 0) {
      history.push('/beneficios');
    }

    // Não é, nem foi, subscriber, go Benefícios
    if (person.person && !IsOrWasSubscriber(person.person.personStatus) && person.subs.length < 1) {
      history.push('/beneficios');
    }

    let subscriberIdList = PossibleSubscriberIds(subscribers, true);
    let filteredEditions = FilterSubscriberByEditions(editions, subscriberIdList);

    let currentEdition =
      filteredEditions.glambox[0] !== undefined ? filteredEditions.glambox[0].editionId : null;

    let currentSubscriber = null;
    if (currentEdition !== null && filteredEditions.subscriberEditions[currentEdition]) {
      currentSubscriber = filteredEditions.subscriberEditions[currentEdition][0];
    }

    this.setState(
      {
        editions: filteredEditions,
        editionsParsed: true,

        subscriberIdList: subscriberIdList,
        subscriberHasSuperbox: filteredEditions.superbox.length > 0,

        currentEdition: currentEdition,
        currentEditionIsSuperbox: false,

        currentSubscriber: currentSubscriber,
      },
      () => {
        if (currentSubscriber !== null) {
          this._loadEdition(currentSubscriber);
        }
      }
    );
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { state, props } = this;

    if (Array.isArray(props.subscribers) && props.subscribers.length === 0) {
      return (
        <div className={'p-2 p-lg-5'}>
          <Helmet>
            <title>Minha Glambox : Caixinha</title>
          </Helmet>

          <h1>Minhas Edições</h1>

          <div className={'p-2 p-lg-5 text-center'}>
            <p className={'lead text-muted'}>Ops! Você ainda não tem nenhuma assinatura ativa!</p>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>Minha Glambox : Caixinha</title>
        </Helmet>

        {this._renderScreen()}

        <Portal>
          <Modal
            visible={state.productFeedbackModal}
            onCloseModal={this._toggleFeedbackModal}
            useDefaultDialog={false}
          >
            <Feedback
              id={state.productFeedbackId}
              isProduct={true}
              onFinish={this._toggleFeedbackModal}
            />
          </Modal>
        </Portal>
        <Portal>
          <Modal
            visible={state.editionFeedbackModal}
            onCloseModal={this._toggleEditionModal}
            useDefaultDialog={false}
          >
            <Feedback
              id={state.activeFeedbackId}
              isProduct={false}
              onFinish={this._toggleEditionModal}
            />
          </Modal>
        </Portal>
      </div>
    );
  }

  // --------------------------------------------------------------------

  _loadEdition = (subscriber) => {
    let { editionDetails, editionProducts, editionFeedback, editionTracking } = this.state;

    this.setState(
      {
        editionDetails: Object.assign({}, editionDetails, {
          data: null,
          pending: true,
          error: null,
        }),
        editionProducts: Object.assign({}, editionProducts, {
          data: null,
          pending: true,
          error: null,
        }),
        editionFeedback: Object.assign({}, editionFeedback, {
          data: null,
          pending: true,
          error: null,
        }),
        editionTracking: Object.assign({}, editionTracking, {
          data: null,
          pending: true,
          error: null,
        }),
      },
      () => {
        this._loadEditionDetails(subscriber);
      }
    );
  };

  _loadEditionDetails = (subscriber) => {
    let { editionDetails } = this.state;

    ExecuteRequest(
      GlamboxEndpoints.Open.editionDetail,
      null,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      {
        editionId: subscriber.editionId,
      },
      (response) => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            editionDetails: Object.assign({}, editionDetails, {
              pending: false,
              data: result,
            }),
          });

          this._loadEditionProducts(subscriber);
        } else {
          this.setState({
            editionDetails: Object.assign({}, editionDetails, {
              pending: false,
              error: result && result.message ? result.message : 'Erro',
            }),
          });

          this.props.publishErrorAlert(result && result.message ? result.message : 'Erro');
        }
      }
    );
  };

  _loadEditionProducts = (subscriber) => {
    let requestData = {
      editionId: subscriber.editionId,
      subscriberId: subscriber.subscriberId,
    };

    let { editionProducts } = this.state;

    ExecuteRequest(
      GlamboxEndpoints.Feedback.listEditionProducts,
      requestData,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          result.sort((a, b) => {
            if (a.activeFeedbackId !== 0 && b.activeFeedbackId !== 0) {
              if (a.feedbackAnswered && !b.feedbackAnswered) {
                return 1;
              } else if (!a.feedbackAnswered && b.feedbackAnswered) {
                return -1;
              }
            } else {
              if (a.activeFeedbackId === 0 && b.activeFeedbackId !== 0) {
                return 1;
              } else if (a.activeFeedbackId !== 0 && b.activeFeedbackId === 0) {
                return -1;
              }
            }
            return 0;
          });

          this.setState({
            editionProducts: Object.assign({}, editionProducts, {
              pending: false,
              data: result,
            }),
          });

          this._loadEditionFeedback(subscriber);
          this._loadEditionTracking(subscriber);
        } else {
          this.setState({
            editionProducts: Object.assign({}, editionProducts, {
              pending: false,
              error: result && result.message ? result.message : 'Erro',
            }),
          });

          this.props.publishErrorAlert(result && result.message ? result.message : 'Erro');
        }
      }
    );
  };

  _loadEditionFeedback = (subscriber) => {
    let requestData = {
      editionId: subscriber.editionId,
    };

    let { editionFeedback } = this.state;

    ExecuteRequest(
      GlamboxEndpoints.Feedback.getEditionFeedback,
      requestData,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState(
            {
              editionFeedback: Object.assign({}, editionFeedback, {
                pending: false,
                data: result[0],
              }),
            },
            () => {
              if (result[0].activeFeedbackId > 0 && result[0].feedbackAnswered === false) {
                this._toggleEditionFeedback(result[0].activeFeedbackId)();
              }
            }
          );
        } else {
          this.setState({
            editionFeedback: Object.assign({}, editionFeedback, {
              pending: false,
              error: result && result.message ? result.message : 'Erro',
            }),
          });
          //this.props.publishErrorAlert(error.message);
        }
      }
    );
  };

  _loadEditionTracking = (subscriber) => {
    let requestData = {
      shippingOrderId: subscriber.edition.shippingOrderId,
    };

    let { editionTracking } = this.state;

    if (subscriber.edition.shippingOrderId === 0) {
      this.setState({
        editionTracking: Object.assign({}, editionTracking, {
          pending: false,
        }),
      });
    } else {
      ExecuteRequest(
        GlamboxEndpoints.Logistics.shippingOrderTrackingStatus,
        null,
        'GET',
        {
          Authorization: this.props.token.Authorization,
        },
        requestData,
        (response) => {
          let { result, statusCode } = response;

          if (statusCode === 200) {
            this.setState({
              editionTracking: Object.assign({}, editionTracking, {
                pending: false,
                data: result,
              }),
            });
          } else {
            this.setState({
              editionTracking: Object.assign({}, editionTracking, {
                pending: false,
                error: result && result.message ? result.message : 'Erro',
              }),
            });
            //this.props.publishErrorAlert(error.message);
          }
        }
      );
    }
  };

  _setCurrentType = (type) => {
    return () => {
      let { editions } = this.state;

      let currentBox = type === 2 ? editions.superbox : editions.glambox;

      let currentEdition = currentBox[0].editionId;
      let currentSubscriber = editions.subscriberEditions[currentEdition][0];

      this.setState(
        {
          currentEdition: currentEdition,
          currentEditionIsSuperbox: type === 2,

          currentSubscriber: currentSubscriber,
        },
        () => {
          if (currentSubscriber !== null) {
            this._loadEdition(currentSubscriber);
          }
        }
      );
    };
  };

  _setCurrentEdition = (editionId) => {
    return () => {
      let { editions } = this.state;

      let isSuperbox = parseInt(editionId / 1000000) === 2;

      let currentSubscriber = null;
      if (editions.subscriberEditions[editionId]) {
        currentSubscriber = editions.subscriberEditions[editionId][0];
      }

      this.props.setCurrentOnState(currentSubscriber);

      this.setState(
        {
          currentEdition: editionId,
          currentEditionIsSuperbox: isSuperbox,

          currentSubscriber: currentSubscriber,
        },
        () => {
          if (currentSubscriber !== null) {
            this._loadEdition(currentSubscriber);
          }
        }
      );
    };
  };

  _setCurrentSubscriber = (subscriber) => {
    return () => {
      let isSuperbox = parseInt(subscriber.editionId / 1000000) === 2;

      this.setState(
        {
          currentEdition: subscriber.editionId,
          currentEditionIsSuperbox: isSuperbox,
          currentSubscriber: subscriber,
        },
        () => {
          this._loadEdition(subscriber);
        }
      );
    };
  };

  _toggleFeedback = (id) => {
    return () => {
      this.setState(
        {
          productFeedbackId: id,
        },
        () => {
          this._toggleFeedbackModal();
        }
      );
    };
  };

  _toggleEditionFeedback = (activeFeedbackId) => {
    return () => {
      this.setState(
        {
          activeFeedbackId: activeFeedbackId,
        },
        () => {
          this._toggleEditionModal();
        }
      );
    };
  };

  _toggleEditionModal = (doUpdateData = false) => {
    this.setState(
      {
        editionFeedbackModal: !this.state.editionFeedbackModal,
      },
      () => {
        if (doUpdateData === true) {
          this._loadEdition(this.state.currentSubscriber);
        }
      }
    );
  };

  _toggleFeedbackModal = (doUpdateData = false) => {
    this.setState(
      {
        productFeedbackModal: !this.state.productFeedbackModal,
      },
      () => {
        if (doUpdateData === true) {
          this._loadEdition(this.state.currentSubscriber);
        }
      }
    );
  };

  _renderGlampartnerDialog = () => {
    const { person } = this.props;

    if (person.person.personStatus !== 14) {
      return (
        <div className={'px-2 px-lg-5'}>
          <div className={'level-2 p-2 p-lg-2 ' + Styles['editions__notReceived__banner']}>
            <div>
              <h5>Ganhe + de R$300 em Too Faced e Becca!</h5>
              <p>
                As 10 Glamgirls que mais acumularem Glampoints esse mês ganham um kit GLOW para
                brilhar nesse verão. Chame suas amigas, participe das campanhas de hashtag e
                responda aos feedbacks para ganhar pontos.
                <br />
                <br />
                <NavLink to={'ganhe-mais-glampoints'} className={'linkAnchor'}>
                  Comece a juntar aqui!
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  _noProductsYet = () => {
    return (
      <div className={'level-2 p-2 p-lg-4 ' + Styles['edition__notReceived']}>
        Os produtos da sua caixinha <strong>estão sendo escolhidos</strong> com muito carinho,{' '}
        <strong>de acordo com o seu perfil de beleza.</strong>
        <br />
        O feedback da edição e produtos aparecerão aqui assim que o mês da edição vigente mudar e
        você receber a sua caixinha!
        <br />
        <br />
        Enquanto isso, aproveite para conferir as novas matérias da <strong>GLAM MAG</strong> e
        assistir as aulas de automaquiagem da Beauty Expert <strong>Juliana Rakoza</strong>{' '}
        disponíveis em{' '}
        <NavLink to={'cursos-online'} className={'linkAnchor'}>
          Conteúdo Exclusivo
        </NavLink>{' '}
        para assinantes.
      </div>
    );
  };

  copyToClip = (id) => {
    return (e) => {
      CopyToClipBoard.copyToClipBoard(id, this.props);
    };
  };

  _renderButtonOrImage = (box, num) => {
    if (box.data.edition.editionId !== num || num === 'normal') {
      return (
        <>
          <div
            className={Styles['editions__header-image']}
            style={{
              backgroundImage: `url('${
                box.data.edition.editionId !== num
                  ? box.data.edition.coverImageUrl
                  : 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18475.png'
              }')`,
            }}
          ></div>
        </>
      );
    } else {
      return (
        <>
          <a
            href={'https://glamshop.com.br/collections/black-friday-2020-glamshop'}
            target={'_blank'}
            className={classnames(
              Styles['editions__header-image'],
              Styles['editions__header-image-link']
            )}
            style={{
              backgroundImage: `url('${
                box.data.edition.editionId !== num
                  ? box.data.edition.coverImageUrl
                  : 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18475.png'
              }')`,
            }}
          ></a>
          <div className={Styles['edition_header_glamshopping_blackfriday_button-area']}>
            <a
              href={'https://glamshop.com.br/collections/black-friday-2020-glamshop'}
              target={'_blank'}
            >
              Eu quero
            </a>
          </div>
        </>
      );
    }
  };

  _renderScreen = () => {
    const { editions } = this.props;

    const { editionDetails, editionProducts, editionFeedback, editionTracking, currentSubscriber } =
      this.state;

    if (editions.editionStatusId) if (this._mounted === false) return null;

    if (
      editionDetails.pending === true ||
      editionProducts.pending === true ||
      editionFeedback.pending === true ||
      editionTracking.pending === true ||
      editionDetails.data === null ||
      editionProducts.data === null
    ) {
      if (Array.isArray(editions) && editions.length === 0) {
        return (
          <div className={classnames('editionsReceived', 'p-2', 'p-lg-5', 'mb-2', 'mb-lg-5')}>
            <h3>Histórico de Edições</h3>
            <p>
              Estamos preparando os dados da sua primeira caixinha! Enquanto espera, que tal
              preencher o perfil de beleza para personalizar ainda mais a sua experiência Glambox?
              😉
            </p>
          </div>
        );
      }

      return (
        <div className={'p-2 p-lg-5 text-center'}>
          <p className={'lead text-muted'}>Carregando...</p>
        </div>
      );
    }

    let classes = ['gbBt'];
    classes.push('small');
    classes.push('flat');

    let hashtag;
    if (currentSubscriber.edition.hashtag) {
      hashtag = <span className={Styles['hashtag']}>#{currentSubscriber.edition.hashtag}</span>;
    } else {
      hashtag = null;
    }

    let match = /^([^\s]+)/.exec(currentSubscriber.boxId);

    return (
      <div>
        <div className={Styles['editions__header']}>
          {/* <a href={"https://google.com"} className={Styles["editions__header-image"]} style={{ backgroundImage: `url('${ editionDetails.data.edition.editionId !== 1202007 ? editionDetails.data.edition.coverImageUrl : 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18475.png' }')` }}>
            
          </a> */}

          {
            this._renderButtonOrImage(editionDetails, 'normal') // 1202011
          }

          <div
            className={classnames(
              Styles['editions__header-text'],
              'p-2',
              'px-lg-5',
              'py-2',
              'py-lg-4'
            )}
          >
            <strong className={'d-block mb-1'}>
              {editionDetails.data.edition.title} {hashtag}
            </strong>
            <h1 className={'mb-1'}>{editionDetails.data.edition.theme}</h1>
            <p>
              <small>{match[0]}</small>

              <button
                onClick={this.copyToClip(match[0])}
                className={classnames(
                  'btn',
                  'btn-sm',
                  'btn-light-pink',
                  Styles['editions__header-copy-button']
                )}
              >
                <i className={'fa fa-copy'} />
                <span className={'d-none d-md-inline ml-md-1'}>Copiar</span>
              </button>
              <span className={'d-none'} id={match[0]}>
                {match[0]}
              </span>
            </p>
          </div>

          {/* <a href="#">TESTE DO BOTÃO</a> */}
        </div>

        {/*
        <div className={"minha_top_boxname"} style={{backgroundImage: `url('${editionDetails.data.edition.coverImageUrl}')`}}>
          <div className={"co"}>
            <strong>{editionDetails.data.edition.title} {hashtag}</strong>
            <h1>{editionDetails.data.edition.theme}</h1>
            <button className={"btn btn-sm btn-link"}>
              Feedback
            </button>
          </div>
        </div>
        */}

        {/* {this._renderGlampartnerDialog()} */}

        <div className={classnames('minha_products', 'px-2', 'px-lg-5', 'mb-2', 'mb-lg-5')}>
          {editionProducts.data.length < 1 ? this._noProductsYet() : <h3>Produtos da caixa</h3>}

          <div className={'products_list'}>{this._renderProductsList()}</div>
        </div>

        {/*
        <div className={classnames(Styles["editions__received"], "px-2", "px-lg-5")}>
          <h3>Histórico de Edições</h3>
          <p>Clique no "Card" para visualizar os detalhes da edição desejada.</p>
          <div className={Styles["editions__received-list"]}>
            <div className={Styles["scroll"]}>
              
            </div>
          </div>
        </div>
        */}

        <div className={classnames('editionsReceived', 'px-2', 'px-lg-5', 'mb-2', 'mb-lg-5')}>
          <h3>Histórico de Edições</h3>
          <p>Clique na "Edição" para visualizar os detalhes da edição desejada.</p>
          <div className={'editions_list'}>
            <div className={'editionsScroll'}>{this._renderPreviousEditions()}</div>
          </div>
        </div>
      </div>
    );
  };

  _renderProductsList = () => {
    const { editionProducts } = this.state;

    let classes = ['gbBt'];
    classes.push('small');
    classes.push('flat');

    return editionProducts.data.map((item, key) => {
      let hashtag = item.hashtag ? (
        <small
          style={{
            color: '#00e381',
            fontWeight: 600,
            textAlign: 'center',
            margin: 0,
            background: 'rgba(0, 227, 129, 0.20)',
            padding: '6px',
            lineHeight: '1em',
            display: 'table',
            width: 'auto',
            position: 'absolute',
            top: '5px',
            left: '5px',
          }}
        >
          <em>{item.hashtag}</em>
        </small>
      ) : null;

      let feedbackButtonDisabled = item.feedbackAnswered === true,
        feedbackModal;

      let feedbackButton =
        item.feedbackAnswered === false && item.activeFeedbackId === 0 ? null : (
          <button
            className={classnames(classes, 'default')}
            disabled={feedbackButtonDisabled}
            style={this.props.styles}
            onClick={this._toggleFeedback(item.productId)}
          >
            Feedback
          </button>
        );

      let _img = item.defaultImageURL.replace('_SML', '_MED');

      return (
        <div className={'item'} key={item.productVariantId}>
          <div
            className={'image b_shadow'}
            style={{
              background: '#ffffff',
              backgroundImage: `url('${_img}')`,
              backgroundSize: 'contain',
            }}
          ></div>
          <div className={'infos_product'}>
            <p>{item.productVariantName}</p>
            {hashtag}
            {feedbackButton}
          </div>
        </div>
      );
    });
  };

  _renderBoxTypeButtons = () => {
    const { editions, currentEdition, currentEditionIsSuperbox } = this.state;

    if (editions.glambox.length > 0 && editions.superbox.length > 0) {
      let _boxes = [
        {
          id: 1,
          name: 'Glambox',
        },
        {
          id: 2,
          name: 'Superbox',
        },
      ];

      return _boxes.map((item, key) => {
        return (
          <button className={'btn btn-light-lime'} onClick={this._setCurrentType(item.id)}>
            {item.name}
          </button>
        );
      });
    }

    return null;
  };

  _renderSubscriberButtons = () => {
    const { editions, currentEdition } = this.state;

    return editions.subscriberEditions[currentEdition].map((item, key) => {
      return (
        <button className={'btn btn-light-pink'} onClick={this._setCurrentSubscriber(item)}>
          {item.boxId}
        </button>
      );
    });
  };

  _renderPreviousEditions = () => {
    const { state } = this;
    let isSuperbox = parseInt(state.currentEdition / 1000000) === 2;

    if (state.currentEditionIsSuperbox) {
      return state.editions.superbox.map((item, key) => {
        if (key >= 12) return null;
        let img = item.coverImageUrl ? <img src={item.coverImageUrl} alt={''} /> : null;

        let active = state.currentEdition === item.editionId;

        return (
          <div
            key={key}
            className={classnames('level-2 itemEdicao', active ? 'isActive' : '')}
            onClick={this._setCurrentEdition(item.id)}
          >
            <div className={'editionContent'}>
              <h3>{item.theme}</h3>
              <small>{item.name}</small>
            </div>
            <div
              className={'thumb'}
              style={{ backgroundImage: `url(${item.coverImageUrl})` }}
            ></div>
          </div>
        );
      });
    }

    if (state.editions.glambox.length < 1) return null;

    return state.editions.glambox.map((item, key) => {
      if (key >= 12) return null;

      let img = item.coverImageUrl ? <img src={item.coverImageUrl} alt={''} /> : null;

      let active = state.currentEdition === item.editionId;

      return (
        <div
          key={key}
          className={classnames('level-2 itemEdicao', active ? 'isActive' : '')}
          onClick={this._setCurrentEdition(item.editionId)}
        >
          <div className={'editionContent'}>
            <h3>{item.theme}</h3>
            <small>{item.name}</small>
          </div>
          <div
            className={'thumb'}
            style={{
              backgroundImage: `url(https://s3.amazonaws.com/Glambox.Content.MediaObject/Edition/${item.editionId}_boxEdition.png)`,
            }}
          ></div>
        </div>
      );
    });
  };
}

const mapStateToProps = (state) => ({
  token: state.token.data,
  person: state.person.data,
  editions: state.editions.data,
  subscribers: state.subscribers.data,
});

const mapDispatchToProps = (dispatch) => ({
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  setCurrentOnState: (current) => {
    dispatch(StateActions.setCurrentSubscriber(current));
  },
});

Caixinha = connect(mapStateToProps, mapDispatchToProps)(Caixinha);

export { Caixinha };
